import React from 'react';
import icCarolus from '../../assets/logo_rs.png';
import icMed from '../../assets/medapp.png';
import icMedKecil from '../../assets/icon-medapp.png';
import { Typography } from '@material-ui/core';
import QRCode from "react-qr-code";
import Constant from '../../library/Constant';

export class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visibleRegis: true,
      strDate: '',
      strTime: ''
    }
  }

  componentDidMount() {
    this.setState({
      visibleRegis: this.props.pembayaran === 'umum' ? false : true
    })
    this.tick()
    this.getDate()
    console.log(this.props);
  }

  getDate() {
    var date = new Date();
    var tahun = date.getFullYear();
    var bulan = date.getMonth();
    var tanggal = date.getDate();
    var hari = date.getDay();
    switch (hari) {
      case 0: hari = "Minggu"; break;
      case 1: hari = "Senin"; break;
      case 2: hari = "Selasa"; break;
      case 3: hari = "Rabu"; break;
      case 4: hari = "Kamis"; break;
      case 5: hari = "Jum'at"; break;
      case 6: hari = "Sabtu"; break;
    }
    switch (bulan) {
      case 0: bulan = "Januari"; break;
      case 1: bulan = "Februari"; break;
      case 2: bulan = "Maret"; break;
      case 3: bulan = "April"; break;
      case 4: bulan = "Mei"; break;
      case 5: bulan = "Juni"; break;
      case 6: bulan = "Juli"; break;
      case 7: bulan = "Agustus"; break;
      case 8: bulan = "September"; break;
      case 9: bulan = "Oktober"; break;
      case 10: bulan = "November"; break;
      case 11: bulan = "Desember"; break;
    }
    let strDate = tanggal + ' ' + bulan + ' ' + tahun
    this.setState({ strDate })
  }

  tick() {
    this.setState({
      jam: new Date().getHours(),
      menit: new Date().getMinutes()
    }, () => {
      var ampm = this.state.jam >= 12 ? 'PM' : 'AM';
      this.state.jam = this.state.jam % 12;
      this.state.jam = this.state.jam ? this.state.jam : 12; // the hour '0' should be '12'
      this.state.menit = this.state.menit < 10 ? '0' + this.state.menit : this.state.menit;
      var strTime = this.state.jam + ':' + this.state.menit + ' ' + ampm;
      this.setState({
        strTime
      })
    });
  }

  render() {
    return (
      <div className='print-source page'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <img src={localStorage.getItem(Constant.LOGO_CETAKAN)} style={{ height: '2.4em', width: '2em', marginRight: '1em' }} />
            <div style={{ alignSelf: 'center' }}>
              <Typography style={{ fontSize: '2mm', fontWeight: 'bold', lineHeight: 1 }}>{localStorage.getItem(Constant.NAMA_RS)}</Typography>
              <Typography style={{ fontSize: '2mm', fontWeight: '300' }}>{localStorage.getItem(Constant.DESCRIPTION_RS)}</Typography>
            </div>
          </div>
          <img src={icMed} style={{ width: '5.2em', height: '1.5em' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5mm' }}>
          <Typography style={{ fontSize: '4mm', fontFamily: 'Poppins', fontWeight: 'bold', textAlign: 'center' }}>Antrian</Typography>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', borderBottomWidth: '.3.5mm', borderBottomStyle: 'solid', borderBottomColor: '#000000', padding: '0mm 0mm 2mm 0mm' }}>
          <Typography style={{ fontSize: '4mm', fontFamily: 'Poppins', fontWeight: 'bold', textAlign: 'center' }}>Farmasi</Typography>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Kode Reservasi </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.kodePesanan === "" ? "-" : this.props.kodePesanan === null ? "-" : this.props.kodePesanan}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>No Rekam Medis </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.medicalRecord === "" ? "-" : this.props.medicalRecord === null ? "-" : this.props.medicalRecord }</Typography>
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Nama Pasien </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.namaPasien}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Lokasi </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.lokasi}</Typography>
          </div>
        </div>
        {/* <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Kode Resep</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>-</Typography>
          </div>
        </div> */}
        <div style={{ display: 'contents', justifyContent: 'center', width: '30%', marginTop: '5mm', }}>
          <div style={{ marginTop: '12mm', display: 'flex', justifyContent: 'center' }}>
            <Typography style={{ fontSize: '3.5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black', textAlign: 'center' }}>No. Antrian</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography style={{ fontSize: '15mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000', fontWeight: 'bold', textAlign: 'center' }}>{this.props.noAntrian}</Typography>
          </div>
          {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '4mm' }}> */}
          {/* </div> */}
        </div>
        {/* <div style={{ marginTop: '4%' }}>
            <Typography style={{ fontStyle: 'italic', fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#333333', textAlign: 'left', marginTop: '4mm' }}>Pastikan anda telah melakukan <b>Registrasi & Pengecekan</b> pada <b>Nurse Station</b> sebelum menunggu antrian dokter</Typography>
        </div> */}
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '6mm' }}>
          <div style={{ display: 'flex', marginTop: '4mm', alignItems: 'center', alignSelf: 'center' }}>
            <img src={icMedKecil} style={{ width: '1em', height: '1em', marginRight: '2mm' }} />
            <Typography style={{ fontSize: '2.2mm', fontFamily: 'Poppins', fontWeight: 'bold', color: '#000000' }}>@2020 Powered By : Eksad Technology</Typography>
          </div>
          <div style={{ marginTop: '4mm' }}>
            <Typography style={{ fontSize: '2.2mm', fontFamily: 'Poppins', fontWeight: 'bold', color: '#000000' }}>{this.state.strTime} {this.state.strDate}</Typography>
          </div>
        </div>
      </div>
    );
  }
}